'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

import WithChannelData from '../DataHOCs/WithChannelData';
import WithProjectData from '../DataHOCs/WithProjectData';
import WithActivityVersionValidationData from '../DataHOCs/WithActivityVersionValidationData';
import ValidationReport from '../validation/ValidationReport';

const propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    channelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    activityId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    validationObj: PropTypes.object.isRequired,
    version: PropTypes.string.isRequired,
};

const defaultProps = {
    show: true,
};

function ActivityValidationReportModal(props) {
    return (
        <Modal
            show={props.show}
            enforceFocus={false}
            backdrop={false}
            animation={false}
            keyboard
            onHide={props.onClose}
        >
            <Modal.Header closeButton onHide={props.onClose}>
                <Modal.Title>Activity Validation</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <h2>Version {props.version}</h2>
                <hr className="thick hr-color-1"/>
                <ValidationReport
                    validationObj={props.validationObj}
                />
            </Modal.Body>
                <Modal.Footer>
                    <Button onClick={props.onClose}>
                        Close
                    </Button>
                </Modal.Footer>
        </Modal>
    );
}

ActivityValidationReportModal.propTypes = propTypes;
ActivityValidationReportModal.defaultProps = defaultProps;

export default WithChannelData(WithProjectData(WithActivityVersionValidationData(ActivityValidationReportModal)));